import { apiClient } from "@api/apiClient";

import { DefaultTopicTypeResponseData } from "./publicationTopicType.interface";

const API_ENDPOINT = "des/publication/filter/topic-type/";

export const publicationTopicTypeApi = {
  getTopicTypeData: async () => {
    const response = await apiClient.get<DefaultTopicTypeResponseData>(
      `${API_ENDPOINT}`,
    );

    return response.data;
  },
};
